class HubSpotAppointmentForm {
    constructor() {
        this.modalId = 'appointment-modal';
        this.overlayId = 'appointment-modal-overlay';
        this.formContainerId = 'hubspot-appointment-form';
        this.triggerSelector = '[href="#BookAppointment"],[data-appointment-trigger]';
        this.closeSelector = '[data-modal-close]';
        this.formLoaded = false;
        this.modalContentSelector = '.form-modal__container'
        this.justOpened = false;
        this.init();
    }

    init() {
        // Check if modal exists in DOM
        this.modal = document.getElementById(this.modalId);
        this.overlay = document.getElementById(this.overlayId);

        if (!this.modal || !this.overlay) {
            console.error('Modal or overlay not found in DOM. Make sure {% render "hubspot-appointment-modal" %} is in theme.liquid');
            return;
        }

        if (!this.isHubSpotEnabled()) {
            console.warn('HubSpot is not enabled or hbspt is undefined.');
            // Still setup triggers so button works, just won't load form
        }

        this.setupTriggers();
        this.setupModalClose();
    }

    isHubSpotEnabled() {
        const enabled = typeof hbspt !== 'undefined' && window.Shopify?.theme?.settings?.hubspot_enabled;
        return enabled;
    }

    setupTriggers() {
        // Use event delegation on document
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest(this.triggerSelector);
            if (trigger) {
                // console.log('Appointment trigger clicked!', trigger);
                e.preventDefault();
                e.stopPropagation();
                this.openModal();
                this.justOpened = true;
                setTimeout(() => { this.justOpened = false; }, 0); // reseting after event loop
                return;
            }
        });
    }

    setupModalClose() {
        // Close button clicks
        document.addEventListener('click', (e) => {
            if (this.justOpened) return;
            const closeBtn = e.target.closest(this.closeSelector);
            if (closeBtn) {
                e.preventDefault();
                e.stopPropagation();
                this.closeModal();
            }
            // Close on clicking outside the modal
            if (this.modal && this.isModalOpen()) {
                const modalContent = this.modal.querySelector(this.modalContentSelector);
                if (modalContent && !modalContent.contains(e.target)) {
                    this.closeModal();
                }
            }
        });

        // ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isModalOpen()) {
                this.closeModal();
            }
        });
    }

    loadForm() {
        if (this.formLoaded) {
            return;
        }

        if (!this.isHubSpotEnabled()) {
            console.error('Cannot load form: HubSpot not enabled');
            return;
        }

        const settings = window.Shopify?.theme?.settings;
        if (!settings?.hubspot_portal_id || !settings?.hubspot_appointment_form_id) {
            console.error('HubSpot settings missing:', settings);
            return;
        }

        // console.log('Loading HubSpot form with settings:', {
        //     portalId: settings.hubspot_portal_id,
        //     formId: settings.hubspot_appointment_form_id,
        //     region: settings.hubspot_region || 'na1',
        // });

        try {
            hbspt.forms.create({
                portalId: settings.hubspot_portal_id,
                formId: settings.hubspot_appointment_form_id,
                target: `#${this.formContainerId}`,
                region: settings.hubspot_region || 'na1',
                onFormReady: ($form) => {
                    // console.log('HubSpot form loaded successfully');
                    this.formLoaded = true;
                },
                onFormSubmit: () => {
                    console.log('HubSpot form submitting...');
                },
                onFormSubmitted: () => {
                    console.log('HubSpot form submitted successfully');
                    // setTimeout(() => {
                    //     console.log('Closing modal after submission');
                    //     this.closeModal();
                    //     // Clear form for next use
                    //     this.formLoaded = false;
                    // }, 2000);
                },
            });
        } catch (error) {
            console.error('Error loading HubSpot form:', error);
        }
    }

    openModal() {
        const modal = document.getElementById(this.modalId);
        const overlay = document.getElementById(this.overlayId);

        if (!modal || !overlay) {
            console.error('Cannot open modal: elements not found');
            return;
        }

        // Load form on first open
        if (!this.formLoaded && this.isHubSpotEnabled()) {
            this.loadForm();
        }

        modal.style.display = 'flex';
        overlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
        modal.setAttribute('aria-hidden', 'false');
    }

    closeModal() {
        const modal = document.getElementById(this.modalId);
        const overlay = document.getElementById(this.overlayId);

        if (modal && overlay) {
            modal.style.display = 'none';
            overlay.style.display = 'none';
            document.body.style.overflow = '';
            modal.setAttribute('aria-hidden', 'true');
        }
    }

    isModalOpen() {
        return this.modal && (this.modal.style.display === 'block' || this.modal.style.display === 'flex');
    }
}

// Initialize - wait for both DOM and defer scripts
function initAppointmentForm() {

    if (!window.hubspotAppointmentForm) {
        window.hubspotAppointmentForm = new HubSpotAppointmentForm();
    }
}

// Try multiple initialization methods to ensure it runs
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppointmentForm);
} else {
    initAppointmentForm();
}

window.addEventListener('load', function() {
    if (!window.hubspotAppointmentForm) {
        initAppointmentForm();
    }
});

// form_submit — new hs-form-frame iframe embed (document-level event)
document.addEventListener('hs-form-event:on-submission:success', function (e) {
    var modal = document.getElementById('appointment-modal');
    if (!modal || modal.style.display === 'none') return;
    var formContainer = document.getElementById('hubspot-appointment-form');
    var hsFrame = formContainer ? formContainer.querySelector('.hs-form-frame') : null;
    var formId = hsFrame ? hsFrame.getAttribute('data-form-id') : (e.detail && e.detail.formId ? e.detail.formId : null);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'form_submit',
        form_name: 'HubSpot Appointment Form',
        form_id: formId
    });
});